import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent({color = '#000', props}: any) {
  return (
    <Svg
      width={70}
      height={70}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M26.25 40.833l17.5-17.5"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <Path
        d="M27.708 26.25a1.458 1.458 0 100-2.917 1.458 1.458 0 000 2.917zM42.292 40.833a1.458 1.458 0 100-2.916 1.458 1.458 0 000 2.916z"
        fill={color}
      />
      <Path
        d="M14.583 61.25V14.583a5.834 5.834 0 015.834-5.833h29.166a5.834 5.834 0 015.834 5.833V61.25l-8.75-5.833-5.834 5.833L35 55.417l-5.833 5.833-5.834-5.833-8.75 5.833z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export default SvgComponent
